module.exports = __webpack_public_path__ + "static/media/PlanPagos2.57607019.jpg";